import { DEFAULT_BLOCK_TAG, LIST_ITEM, LIST_ELEMENTS} from '../constants/editable-elements';
import isElementChildNodesToWrap from '../verifiers/is-element-child-nodes-to-wrap';
import wrapChildNodesIntoElement from './wrap-child-nodes-into-element';

const wrapListItemChildNodesIntoParagraph = (listItems) => {
  const elementsChildNodesToWrap = listItems.filter(isElementChildNodesToWrap);
  elementsChildNodesToWrap.forEach((el) => wrapChildNodesIntoElement(el, DEFAULT_BLOCK_TAG));
};

const wrapListItemsIntoPermittedParent = (listItems) => {
  const listItemsWithoutPermittedParent = listItems.filter(
    (el) => !el.parentElement || !LIST_ELEMENTS.includes(el.parentElement.tagName.toLowerCase())
  );

  if (!listItemsWithoutPermittedParent.length) {
    return;
  }

  const groupListItemsWithoutPermittedParent = listItemsWithoutPermittedParent.reduce((acc, el) => {
    const lastGroup = acc[acc.length - 1];

    if (
      lastGroup &&
      lastGroup[lastGroup.length - 1].nextElementSibling === el
    ) {
      lastGroup.push(el);
    } else {
      acc.push([el]);
    }

    return acc;
  }, []);

  groupListItemsWithoutPermittedParent.forEach((group) => {
    const list = document.createElement('ul');
    group[0].before(list);
    list.append(...group);
  });
}

const handleListItemsAfterClipboardPreparation = (rootElement) => {
  const listItems = [...rootElement.querySelectorAll(LIST_ITEM)];

  // in case if list item content is not wrapped into block element, we have to wrap the content of each item in a `<p>` tag for correct work with editing the text of list items
  wrapListItemChildNodesIntoParagraph(listItems);

  // in some cases, list items can be without permitted parent list element, so we need to wrap them in a `<ul>` tag
  wrapListItemsIntoPermittedParent(listItems);
};

export default handleListItemsAfterClipboardPreparation;
